//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "time",
  data: function data() {
    return {
      check: null
    };
  },
  computed: {
    time: function time() {
      return this.option.time;
    }
  },
  watch: {
    time: {
      handler: function handler(val) {
        var _this = this;

        if (val > 0) {
          setTimeout(function () {
            _this.startTime();
          }, 1000);
        } else {
          this.stopTime();
        }
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.echartFormatter && this.echartFormatter(this.getItemRefs());
  },
  methods: {
    startTime: function startTime() {
      var _this2 = this;

      this.stopTime();
      this.check = setInterval(function () {
        _this2.echartFormatter && _this2.echartFormatter(_this2.getItemRefs());
      }, this.time);
    },
    stopTime: function stopTime() {
      clearInterval(this.check);
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});